const screenViewSelfieOnly = {
    ConfirmarIdentidade          : '/start/selfie-only',
    SelfieIntroducao             : '/selfie-instructions/selfie-only',
    TermoUso                     : '/terms-of-use/selfie-only',
    ModalCamera                  : '/error-cant-access-camera/selfie-only',
    Selfie                       : '/selfie/selfie-only',
    SelfieError                  : '/selfie/selfie-only/selfie-error-2',
    Analise                      : '/identity-confirmation/selfie-only',

}

const screenViewDoc = {

    SelfieIntroducao             : '/selfie-instructions/doc',
    ConfirmarIdentidade          : '/start/doc',
    TermoUso                     : '/terms-of-use/doc',
    ModalCamera                  : '/error-cant-access-camera/doc',

    Selfie                       : '/selfie/doc',
    SelfieError                  : '/selfie/doc/selfie-error-2',
    DocSelecao                   : '/document-selection/doc',

    CnhDigital                   : '/file-selection/doc',
    ErroAcessoCnhDigital         : '/error-cant-access-your-documents/doc',
    ErroUploadCnhDigital         : '/error-cant-attached-your-cnh/doc',

    DocIntroducaoCnhFront        : '/drivers-license/front-instructions/doc',
    DocIntroducaoCnhBack         : '/drivers-license/back-instructions/doc',

    DocIntroducaoRgFront         : '/id-card/front-instructions/doc',
    DocIntroducaoRgBack          : '/id-card/back-instructions/doc',

    DocIntroducaoOutrosFront     : '/other-documents/front-instructions/doc',
    DocIntroducaoOutrosBack      : '/other-documents/back-instructions/doc',



    DocDigitalizacaoCnhFront     : '/drivers-license/front-picture/doc',
    DocDigitalizacaoCnhBack      : '/drivers-license/back-picture/doc',

    DocDigitalizacaoRgFront      : '/id-card/front-picture/doc',
    DocDigitalizacaoRgBack       : '/id-card/back-picture/doc',

    DocDigitalizacaoOutrosFront  : '/other-documents/front-picture/doc',
    DocDigitalizacaoOutrosBack   : '/other-documents/back-picture/doc',



    checkDocCnhFrontPicture      : '/drivers-license/check-front-picture/doc',
    checkDocCnhBackPicture       : '/drivers-license/check-back-picture/doc',

    checkDocRgFrontPicture       : '/id-card/check-front-picture/doc',
    checkDocRgBackPicture        : '/id-card/check-back-picture/doc',

    checkDocOutrosFrontPicture   : '/other-documents/check-front-picture/doc',
    checkDocOutrosBackPicture    : '/other-documents/check-back-picture/doc',


    DocError1                    : '/document-error-1',
    DocError2                    : '/document-error-2',
    DocError3                    : '/document-error-3',

    Analise                      : '/identity-confirmation/doc',
}

export default {
    screenViewSelfieOnly,
    screenViewDoc
}



// WEBPACK FOOTER //
// ./src/utils/enumScreenView.js